<app-dialog-layout>
  <ng-container content>
    <div class="dialog-content-form-renderer">
      <cpb-form-renderer [showHeader]="false" [formKey]="formKey" [context]="context" [modelId]="itemId">
      </cpb-form-renderer>
    </div>
  </ng-container>

  <ng-container buttons>
    <cap-button
      icon="fal fa-times"
      styleClass="secondary"
      [label]="'button.cancel' | translate"
      (onClick)="dialogRef.close()">
    </cap-button>

    <cap-button
      styleClass="primary"
      icon="fas fa-floppy-disk"
      [label]="'market_discovery.button.save' | translate"
      (onClick)="handleSave()">
    </cap-button>
  </ng-container>
</app-dialog-layout>
